import { axiosGet, axiosPost } from './axiosService';

export class AbsherService {
	requestVerification() {
		return axiosPost(null, 'users/absher/request', {
			hide_success_toaster: true,
		});
	}

	getStatus() {
		return axiosGet(null, 'users/absher/status', null, null, {
			hide_toaster: true,
		});
	}
}
